function EgdsStylesPlugin() {
    return {
        name: 'egds-styles',
    };
}

export { EgdsStylesPlugin as default };
//# sourceMappingURL=browser.js.map
